import { observable } from 'mobx'
import { observer } from 'mobx-react'
import React from 'react'
import { FieldError } from '../../atoms/FieldError'
import { FieldNo } from '../../atoms/FieldNo'
import { HideTablet } from '../../atoms/HideTablet'
import { Input } from '../../atoms/Input'
import { IntakeStepCol } from '../../atoms/IntakeStepCol'
import { IntakeStepContainer } from '../../atoms/IntakeStepContainer'
import { IntakeStepNoColTablet } from '../../atoms/IntakeStepNoColTablet'
import { PressEnterHint } from '../../molecules/PressEnterHint'
import { WithLabel } from '../../molecules/WithLabel'
import { GetOwnIntakeQuery_getOwnIntake, UpdateOwnIntakeMutationVariables,
  } from '../../schema/schemaTypes'

interface IProps {
  id: string
  active: boolean
  currentIndex: number
  activeValue: string,
  onChange: (value: any) => void
  handleSubmit: (vars: UpdateOwnIntakeMutationVariables, goToNext: boolean) => void
  intake: GetOwnIntakeQuery_getOwnIntake
  isCompleted: boolean
  label: string
  name: string
  no: number
  placeholder: string
  validationError?: (value: string) => null | string
  strToVal?: (value: string) => any
  valToStr?: (value: any) => string
}

@observer
export class IntakeStepInputText extends React.Component<IProps> {

  public textInput: React.RefObject<HTMLInputElement>

  @observable private value = ''
  @observable private validationError: null | string = null

  constructor(props: any) {
    super(props)
    this.textInput = React.createRef()
  }

  public componentWillMount() {
    const { intake, name, valToStr } = this.props

    this.value = valToStr ? valToStr(intake[name]) : intake[name] || ''
  }

  public componentDidMount() {
    if (this.props.active && this.textInput.current) {
      this.textInput.current.focus()
    }

    if (this.props.active && this.props.activeValue) {
      this.value = this.props.activeValue
    }
  }

  public render () {
    const { active, id, isCompleted, label, no, placeholder } = this.props
    const value = this.value

    return (
      <IntakeStepContainer id={id} active={active}>
        <IntakeStepNoColTablet>
          <FieldNo checked={isCompleted}>{no}</FieldNo>
        </IntakeStepNoColTablet>
        <IntakeStepCol>
          <WithLabel label={<><HideTablet><FieldNo checked={isCompleted}>{no}</FieldNo></HideTablet>{label}</>}>
            {inputId => <Input
              name="field" id={inputId} placeholder={placeholder} style={{ maxWidth: 620 }} disabled={!active}
              onChange={this.handleChange} onBlur={this.handleSubmitNoNext} onKeyDown={this.handleKeyDown} value={value}
              ref={this.textInput}
            />}
          </WithLabel>
          {this.validationError && <FieldError>{this.validationError}</FieldError>}
          <PressEnterHint />
        </IntakeStepCol>
      </IntakeStepContainer>
    )
  }

  private handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.props.onChange(e.currentTarget.value)
    this.value = e.currentTarget.value
    if (this.props.validationError && this.validationError !== null) {
      this.validationError = this.props.validationError(this.value)
    }
  }

  private handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === 'Tab'){
      e.stopPropagation()
      e.preventDefault()
      this.handleSubmit()
    }
  }

  private handleSubmit = () => {
    const { validationError, strToVal, handleSubmit, name } = this.props

    if (validationError) {
      this.validationError = validationError(this.value)
      if (this.validationError !== null) {
        return
      }
    }

    const val = strToVal ? strToVal(this.value) : this.value

    handleSubmit({ [name]: val }, true)
    
  }

  private handleSubmitNoNext = () => {
    const { validationError, strToVal, handleSubmit, name } = this.props

    if (validationError) {
      this.validationError = validationError(this.value)
      if (this.validationError !== null) {
        return
      }
    }

    const val = strToVal ? strToVal(this.value) : this.value
    handleSubmit({ [name]: val }, false)
  }
}



// WEBPACK FOOTER //
// ./src/organisms/Intakes/IntakeStepInputText.tsx